export type NavChild = {
  label: string;
  href: string;
  description: string;
};

export type NavItem = {
  label: string;
  href: string;
  children?: NavChild[];
};

export const navigation: NavItem[] = [
  {
    label: 'La marque',
    href: '/la-marque',
    children: [
      { label: 'Notre histoire', href: '/la-marque/notre-histoire', description: 'Une marque familiale née de l’aloe vera andalou.' },
      { label: 'Nos engagements', href: '/la-marque/engagements', description: 'Culture éco-responsable et empreinte carbone réduite.' },
      { label: 'Nos certifications', href: '/la-marque/certifications', description: 'Ecocert, Cosmos Organic et Agriculture Biologique.' },
    ],
  },
  {
    label: 'Les produits',
    href: '/produits',
    children: [
      { label: 'Cosmétiques', href: '/produits/cosmetiques', description: 'Gels, crèmes et soins certifiés bio à l’aloe vera.' },
      { label: 'Compléments alimentaires', href: '/produits/complements-alimentaires', description: 'Jus et compléments à base d’aloe vera fraîche.' },
    ],
  },
  { label: 'Labo des conseils', href: '/labo-des-conseils' },
  { label: 'Points de vente', href: '/points-de-vente' },
  { label: 'Contact', href: '/contact' },
];

export const legalLinks = [
  { label: 'Mentions légales', href: '/mentions-legales' },
  { label: 'Politique de confidentialité', href: '/confidentialite' },
  { label: 'Gestion des cookies', href: '/cookies' },
];
